import React from 'react'

import People from '..'

const Users = () => <People external={false} />

export default Users
